import { alpha } from "@mui/material";
import Image from "src/components/Image";

// ----------------------------------------------------------------------

const shadowIcon = (color: string) => `drop-shadow(2px 2px 2px ${alpha(color, 0.48)})`;

export const CustomIlustration = () => {
	return (
		<Image
			src={`/ilustrations/setup-analytics-amico.svg`}
			sx={{
				filter: (theme) => shadowIcon(theme.palette.primary.main),
				height: 211,
				width: 390
			}}
		/>
	);
};

export default CustomIlustration;
